// frontend/src/App.js - VERSION COMPLÈTE

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import MainLayout from './components/Layout/MainLayout';
import ProtectedRoute from './components/Layout/ProtectedRoute';

// Pages publiques
import Home from './components/Home';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import VerifyEmail from './components/Auth/VerifyEmail';
import ResendVerification from './components/Auth/ResendVerification';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';

// Pages utilisateur
import UserDashboard from './components/Dashboard/UserDashboard';
import MesDossiers from './components/MesDossiers';
import DossierDetails from './components/Dossier/DossierDetails';
import Notifications from './components/Notifications/Notifications';
import Profile from './components/Profile';
import Settings from './components/Settings';
import CompleteProfile from './components/CompleteProfile';
import CreateDossierWithType from './components/Dossier/CreateDossierWithType';
import WorkVisaPreferences from './components/Dossier/Preferences/WorkVisaPreferences';
import StudyVisaPreferences from './components/Dossier/Preferences/StudyVisaPreferences';
import UserMessages from './components/Chat/UserMessages';

// Pages admin
import AdminDashboard from './components/Dashboard/AdminDashboard';
import AdminUsers from './components/Admin/AdminUsers';
import AdminDossiers from './components/Admin/AdminDossiers';
import AdminMessages from './components/Chat/AdminMessages';
import AdminDossierDetails from './components/Admin/AdminDossierDetails';

// Pages superadmin
import SuperAdminDashboard from './components/SuperAdmin/SuperAdminDashboard';
import SuperAdminManageAdmins from './components/SuperAdmin/SuperAdminManageAdmins';
import SuperAdminSettings from './components/SuperAdmin/SuperAdminSettings';
import SuperAdminSystemLogs from './components/SuperAdmin/SuperAdminSystemLogs';
import SuperAdminStatistics from './components/SuperAdmin/SuperAdminStatistics';

// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/GlobalStyles.css';

function App() {
    return (
        <AuthProvider>
            <Router>
                <MainLayout>
                    <Routes>
                        {/* Routes publiques */}
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/verify-email/:token" element={<VerifyEmail />} />
                        <Route path="/resend-verification" element={<ResendVerification />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:token" element={<ResetPassword />} />
                        
                        {/* Routes utilisateur */}
                        <Route 
                            path="/dashboard" 
                            element={
                                <ProtectedRoute>
                                    <UserDashboard />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/mes-dossiers" 
                            element={
                                <ProtectedRoute>
                                    <MesDossiers />
                                </ProtectedRoute>
                            } 
                        />
                        <Route path="/dossier/create" element={<ProtectedRoute><CreateDossierWithType /></ProtectedRoute>} />
                        <Route 
                            path="/dossier/:id" 
                            element={
                                <ProtectedRoute>
                                    <DossierDetails />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/notifications" 
                            element={
                                <ProtectedRoute>
                                    <Notifications />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/chat" 
                            element={
                                <ProtectedRoute>
                                    <UserMessages />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/profile" 
                            element={
                                <ProtectedRoute>
                                    <Profile />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/settings" 
                            element={
                                <ProtectedRoute>
                                    <Settings />
                                </ProtectedRoute>
                            } 
                        />

                        {/* Routes complétion profil et préférences */}
                        <Route path="/profile/complete" element={<ProtectedRoute><CompleteProfile /></ProtectedRoute>} />
                        <Route 
                            path="/dossier/:id/work-preferences" 
                            element={
                                <ProtectedRoute>
                                    <WorkVisaPreferences />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/dossier/:id/study-preferences" 
                            element={
                                <ProtectedRoute>
                                    <StudyVisaPreferences />
                                </ProtectedRoute>
                            } 
                        />
                        
                        {/* Routes admin */}
                        <Route 
                            path="/admin" 
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/admin/users" 
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminUsers />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/admin/dossiers" 
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminDossiers />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/admin/pending" 
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminDossiers />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/admin/chat" 
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminMessages />
                                </ProtectedRoute>
                            } 
                        />


                        <Route 
                            path="/admin/dossier/:id" 
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminDossierDetails />
                                </ProtectedRoute>
                            } 
                        />

                        {/* Routes superadmin */}
                        <Route
                            path="/superadmin"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <SuperAdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/superadmin/admins"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <SuperAdminManageAdmins />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/superadmin/users"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <AdminUsers />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/superadmin/dossiers"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <AdminDossiers />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/superadmin/chat"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <AdminMessages />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/superadmin/settings"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <SuperAdminSettings />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/superadmin/system-logs"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <SuperAdminSystemLogs />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/superadmin/statistics"
                            element={
                                <ProtectedRoute superAdminOnly>
                                    <SuperAdminStatistics />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </MainLayout>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </Router>
        </AuthProvider>
    );
}

export default App;